import React, { Component } from "react";


export class SubmissionHistoryFilter extends Component {
  constructor(props) {
      return super();
  }

  render() {
    let setFilter = (filterName) => {
        if (this.props.activeFilter === filterName) {
          if (filterName !== 'All') {
            this.props.filter('All', true);
            this.props.setActiveFilter('All');
          }
        } else {
            this.props.filter(filterName, true);
            this.props.setActiveFilter(filterName);
        }
    };

    var content = (
        <div className="solicitation-actions">
            <div className="solicitation-filter-btns">
                <button className="btn" onClick={() => { setFilter('All') }}>
                    <span>{this.props.solicitationsSubmittedTo.solicitationsSubmitted}</span>
                    <span>Solicitations Submitted To</span>
                </button>
                {/*<button className={`btn ${this.props.activeFilter === 'All' ? 'active' : ''}`} onClick={() => { setFilter('All') }}>
                    <span>{this.props.solicitationsSubmittedTo.solicitationsSubmitted}</span>
                    <span>Solicitations Submitted To</span>
                </button>*/}
                <button className={`btn ${this.props.activeFilter === 'OpenSolicitations' ? 'active' : ''}`} onClick={() => { setFilter('OpenSolicitations') }}>
                    <span>{this.props.solicitationsSubmittedTo.openSolicitationCount}</span>
                    <span>Open Solicitations</span>
                </button>
                <button className={`btn ${this.props.activeFilter === 'Proposals' ? 'active' : ''}`} onClick={() => { setFilter('Proposals') }}>
                    <span>{this.props.solicitationsSubmittedTo.submittedProposals}</span>
                    <span>Submitted Proposals</span>
                </button>
            </div>
            <span>Select to filter solicitations below</span>
        </div>
    );

    return (
      /*this.props.solPageModel ?*/ content /*: ''*/
    );
  }
}

export default SubmissionHistoryFilter;
